import React, { useEffect, useState } from "react";
import Transactions from "./TransactionTable";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import faker from "faker";
import SmartDataTable from "react-smart-data-table";
import Loader from "../loader";
import { EventDetailTransaction } from "../../../actions/auth";

const generateData = (transactionlist = 0, numTransactResults = 0) => {
  let total = numTransactResults || 0;
  if (typeof numTransactResults === "string") {
    total = parseInt(numTransactResults, 10);
  }
  const TransactionTable = [];
  for (let i = 0; i < total; i += 1) {
    //   var a = i;

    TransactionTable.push({
      fullName: transactionlist[i]?.maximum_participants,
      transactionid: transactionlist[i]?.transaction_id,
      datetime: transactionlist[i]?.billing_date.slice(0, 10),
      amount: transactionlist[i]?.value,
      action: faker?.address?.city(),
    });
  }
  return TransactionTable;
};

const TransactionsData = ({ id }) => {
  const dispatch = useDispatch();
  const [numTransactResults, setNumTransactResults] = useState(0);
  const [TransactionsTable, setTransactionsTable] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(async () => {
    await dispatch(EventDetailTransaction(id)).then((res) => {
      console.log("yes", res);
      res &&
        res.data &&
        setTransactionsTable(generateData(res.data, res.data.length));
      res && res.data && setNumTransactResults(res.data.length);
      res && res.data && setTotalCount(res.data);
    }, []);
  }, []);

  const headers = {
    fullName: {
      text: "Description",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <div className="StudentData">
              <p>Max {value}</p>
            </div>
          </>
        );
      },
    },
    transactionid: {
      text: "Transaction ID",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    datetime: {
      text: "Billing date",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    amount: {
      text: "amount",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>${value}</p>
          </>
        );
      },
    },
    action: {
      text: "Action",
      invisible: false,
      sortable: false,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <Link to="#" className="edit-userbtn">
              <i className="far fa-eye"></i>
            </Link>
          </>
        );
      },
    },
  };
  return (
    <div className="transactionsData">
      <div className="container-fluid">
        <SmartDataTable
          data={TransactionsTable}
          responsive={true}
          name="test-table"
          className="ui compact selectable table eventsDataTable"
          sortable
          headers={headers}
          emptyTable={
            <div
              style={{
                alignSelf: "center",
                textAlign: "center",
                marginTop: "15px",
              }}
            >
              No Records Found
            </div>
          }
        />
        {/* <Transactions/> */}
      </div>
    </div>
  );
};

export default TransactionsData;
